<template>
    <tr class="table-party-list-row">
        <td>
            <NumberInput
                ref="preferredMinSizeInput"
                :options="{ min: 1 }"
                @update:model-value="onUpdatePreferredMinimumSize"
                :model-value="tableParty.preferredMinimumSize"
            />
        </td>
        <td>
            <NumberInput
                ref="maximumSizeInput"
                @update:model-value="onUpdateMaximumSize"
                :options="{ min: 1 }"
                :model-value="tableParty.maximumSize"
            />
        </td>
        <td>
            <Button
                v-if="removeEnabled"
                @click="removeTableParty(tableParty)"
                style="background-color: #fd397a; border-color: #fd397a"
                class="btn-danger"
                icon="la la-trash"
                aria-label="Cancel"
            />
        </td>
    </tr>
</template>

<script setup lang="ts">
    
    import type { ITableSplitToCreateOrUpdate } from "@/data/model/ITableCombination";
    import { ref } from "vue";

    import NumberInput from "@/portal/components/elements/NumberInput.vue";
    import Button from "primevue/button";

    const props = defineProps<{
        removeEnabled: boolean;
        tableParty: ITableSplitToCreateOrUpdate;
    }>();
    
    const preferredMinSizeInput = ref<InstanceType<typeof NumberInput> | null>(null);
    const maximumSizeInput = ref<InstanceType<typeof NumberInput> | null>(null);

    const emit = defineEmits(["onRemoveTableParty"]);
    
    function removeTableParty(tablePartyToRemove: ITableSplitToCreateOrUpdate) {
        emit("onRemoveTableParty", tablePartyToRemove);
    }

    function onUpdateMaximumSize(value: number | undefined) {
        props.tableParty.maximumSize = value;
    }

    function onUpdatePreferredMinimumSize(value: number | undefined) {
        props.tableParty.preferredMinimumSize = value;
    }

    function validate(): boolean {
        let hasErrors = false;

        preferredMinSizeInput.value!.setError(false);
        maximumSizeInput.value!.setError(false);

        if (props.tableParty.preferredMinimumSize == null || props.tableParty.preferredMinimumSize < 1) {
            preferredMinSizeInput.value!.setError(true);
            hasErrors = true;
        }

        if (props.tableParty.maximumSize == null || props.tableParty.maximumSize < 1) {
            maximumSizeInput.value!.setError(true);
            hasErrors = true;
        }

        if ((props.tableParty.preferredMinimumSize ?? 0) > (props.tableParty.maximumSize ?? 0)) {
            maximumSizeInput.value!.setError(true);
            preferredMinSizeInput.value!.setError(true);
            hasErrors = true;
        }

        return !hasErrors;
    }

    defineExpose({
        validate,
    });
</script>

<style scoped lang="scss">
    .table-party-list-row {
        td {
            padding: 7.5px;
        }
    }
</style>
